"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _TitleConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Title-concur_android.css") : void 0);
var _TitleConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Title-concur_default.css") : void 0);
var _TitleConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Title-concur_gateway.css") : void 0);
var _TitleConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Title-concur_ios.css") : void 0);
var _TitleSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Title-sap_fiori_3_dark.css") : void 0);
var _TitleSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Title-sap_fiori_3_hcb.css") : void 0);
var _TitleSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Title-sap_fiori_3_hcw.css") : void 0);
var _TitleSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Title-sap_fiori_3.css") : void 0);
var _TitleSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Title-sap_horizon_dark.css") : void 0);
var _TitleSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Title-sap_horizon_hcb.css") : void 0);
var _TitleSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Title-sap_horizon_hcw.css") : void 0);
var _TitleSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Title-sap_horizon.css") : void 0);
var _excluded = ["className", "classNameMap", "children", "headingLevel", "headingStyle"];
var styles = {
  concur_android: _TitleConcur_android.default,
  concur_default: _TitleConcur_default.default,
  concur_gateway: _TitleConcur_gateway.default,
  concur_ios: _TitleConcur_ios.default,
  sap_fiori_3_dark: _TitleSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _TitleSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _TitleSap_fiori_3_hcw.default,
  sap_fiori_3: _TitleSap_fiori_.default,
  sap_horizon_dark: _TitleSap_horizon_dark.default,
  sap_horizon_hcb: _TitleSap_horizon_hcb.default,
  sap_horizon_hcw: _TitleSap_horizon_hcw.default,
  sap_horizon: _TitleSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-title';

/**
 * The **Title** component provides a way to make headings accessible by
 * separating the heading tag from the heading style, allowing for more
 * flexibility in design while still adhering to accessibility best practices.
 *
 * As a general accessibility rule, it's not ideal to truncate text.  There are
 * certain circumstances, however, that do necessitate a truncation pattern.
 * In cases like this, consult the CSS Helper Mixins patterns:
 * - [Text Overflow](./?path=/docs/patterns-css-helper-mixins--docs#text-overflow)
 * - [Text Overflow
 * Clamp](./?path=/docs/patterns-css-helper-mixins--docs#text-overflow-clamp)
 */

var Title = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var className = props.className,
    classNameMap = props.classNameMap,
    children = props.children,
    headingLevel = props.headingLevel,
    headingStyle = props.headingStyle,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(classNameMap);
  var headingClassTag = headingStyle ? "h".concat(headingStyle) : "h".concat(headingLevel);
  var classes = classnames(CSS_BLOCK, "".concat(CSS_BLOCK, "--").concat(headingClassTag), className);
  var HeadingTag = "h".concat(headingLevel);
  return /*#__PURE__*/_react.default.createElement(HeadingTag, (0, _extends2.default)({}, otherProps, {
    className: classes,
    ref: ref
  }), children);
});
Title.displayName = 'Title';
Title.propTypes = {
  /** Semantic level of the heading to use.  Will use the `<h#>` element in the markup. */
  headingLevel: _CustomPropTypes.default.range(1, 6).isRequired,
  /** Contents of the heading element. */
  children: _propTypes.default.node,
  /** Additional classname(s) to add to the `<h#>` element. */
  className: _propTypes.default.string,
  /** Heading level style to use when rendering the component.  This does not change
   * the semantic heading level of the element. */
  headingStyle: _CustomPropTypes.default.range(1, 6)
};
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(Title);
exports.default = _default;